module.exports = "/packs/pattern-left-blue-46238c2c8d435c75b73faf1a9d6a89d2.png";